
  <mat-toolbar>{{"Select Job Site(S) To Add" | translate | async}}</mat-toolbar>
  <div class="DialogBoxJSL">
<div class="SelectUser">

<!--<h4>Job Site</h4>-->

  <mat-form-field class="MFF">
    <mat-label>{{"Job Site" | translate | async}}</mat-label>
     <mat-select (selectionChange)="jobsiteChanged($event)" [(ngModel)]="selectedSiteId">
      <mat-option *ngFor="let option of jobsitebyCustomerID" [value]="option.crsf_auto" (click)="onChangeCustomer(option)">
        {{option.site_name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

</div>
  <div class="UserListMain">
    <h4>{{"User" | translate | async}}</h4>
    <div>
    <mat-selection-list  class="UserList" #arra1 [(ngModel)]="selectedOptions1" >
      <mat-list-option *ngFor="let item of array1" [value]="item">
        {{item.username | aesDecrypt}}
      </mat-list-option>
    </mat-selection-list>
    </div> 

    <div class="AddOrReBtn">
      <button mat-stroked-button class="AddBtn" (click)="AddItem()">>></button>
      <button mat-stroked-button class="RemoveBtn" (click)="RemoveItem()"><<</button>
    </div>
    
    <div>
      <mat-selection-list  class="UserList" #arra2 [(ngModel)]="selectedOptions2" >
        <mat-list-option *ngFor="let item of array2" [value]="item">
          {{item.username | aesDecrypt}}
        </mat-list-option>
      </mat-selection-list>
      </div>
  </div>

  <div class="DialogBoxJSLBtn">
    <button mat-stroked-button class="AddNewUserJSLAddBtn" (click)="AddNewUsertoJobsite()">{{"Add" | translate | async}}</button>
    <button mat-stroked-button class="AddNewUserJSLClsBtn" (click)="DialogClose()" >{{"Close" | translate | async}}</button>
  </div>

</div>
